MicroModal.init({
  disableScroll: true,
  awaitCloseAnimation: false,
  awaitOpenAnimation: false,
  onClose: (modal) => {
    // 閉じたら動画停止（音も止める）
    modal.querySelectorAll("video").forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });
  },
});

// liをキーボードEnter/Spaceでも開けるように
document.addEventListener("keydown", (e) => {
  const item = e.target.closest(".introduction-item[data-micromodal-trigger]");
  if (!item) return;

  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    const id = item.getAttribute("data-micromodal-trigger");
    MicroModal.show(id);
  }
});
